/* import __COLOCATED_TEMPLATE__ from './install-permissions.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { type PulseAccordion } from 'glint/pulse';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import type IntlService from 'embercom/services/intl';
import { type SalesforceSetupData } from 'embercom/objects/standalone/salesforce';

interface Args {
  accordion: PulseAccordion;
  onContinue: () => void;
}

interface Signature {
  Args: Args;
}

export default class InstallPermissionsComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;

  get salesforceConfig(): SalesforceConfiguration {
    return this.finStandaloneService.salesforceConfig!;
  }

  get salesforceSetupData(): SalesforceSetupData {
    return this.finStandaloneService.salesforceSetupData;
  }

  get isDisabled() {
    return this.salesforceConfig?.isPendingSetup || false;
  }

  get isComplete() {
    return this.salesforceSetupData.hasPermissionSet;
  }

  get isLoading() {
    return (
      this.finStandaloneService.salesforceDataLoader.isLoadingSalesforceSetupData ||
      (this.finStandaloneService.salesforceDataLoader.isLoadingSalesforcePermissions &&
        !this.salesforceSetupData.hasPermissionSet)
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Connect::InstallPermissions': typeof InstallPermissionsComponent;
  }
}
